import { ClientOngoingLoad, Truck } from '@numeo/types-core'
import { useAppDispatch } from 'hooks'
import { setLoadAssignmentMode, setSelectedLoad, setSelectedLoadId, setSelectedTruck } from 'store/loadsSlice'
import { setAssignTruckModalOpen } from 'store/ongoingLoadsSlice'
import { getCompletedLoadLockReason, isCompletedLoadCorrectable, isDeliveredLoadStatus } from '../../../utils/loadStatus'

export const ASSIGN_DISABLED_TOOLTIP = 'Cannot assign a driver to a cancelled load.'

/**
 * Why this load's truck and driver cannot be changed from the page, or `undefined` when they can. Same rule as the Ongoing Loads
 * table (`AssignmentCell`): a completed load stays correctable unless it is split or its payroll statement is locked.
 */
export const getAssignmentDisabledReason = (load: ClientOngoingLoad): string | undefined => {
    if (!isDeliveredLoadStatus(load.status) || isCompletedLoadCorrectable(load)) return undefined
    return getCompletedLoadLockReason(load) ?? ASSIGN_DISABLED_TOOLTIP
}

/** Opens the TruckAssignmentModal for this load, mirroring AssignmentCell's dispatch sequence. */
export const useOpenAssignmentModal = (load: ClientOngoingLoad, truck: Truck | null) => {
    const dispatch = useAppDispatch()
    const open = () => {
        dispatch(setLoadAssignmentMode('single'))
        dispatch(setSelectedTruck(truck))
        dispatch(setAssignTruckModalOpen(true))
        dispatch(setSelectedLoadId(load.id))
        dispatch(setSelectedLoad(load))
    }
    const disabledReason = getAssignmentDisabledReason(load)
    return { open, isDisabled: disabledReason !== undefined, disabledReason }
}
